import { connect } from "react-redux";

import { getE212DropdownList, getCountryDropdownList, getOperatorDropdownList } from "actions/e212";
import { getReferencesForReports } from "actions/references";
import {
    createFakeDLR,
    modifyFakeDLR,
    modifyMultirowFakeDLR,
    removeFakeDLR,
    getFakeDLRList,
    getFakeDLRSupplierList,
    testFakeDLRRule
} from "actions/fake_dlr";
import FakeDLRPage from "./FakeDLRPage";
import { getSupplierDropdownList } from "actions/suppliers";


const mapState = ({ auth, fake_dlr, references, suppliers, e212 }) => ({
    loading: fake_dlr.loading,
    data: fake_dlr.list,
    dropdownList: fake_dlr.dropdown_list,
    page: fake_dlr.page,
    count: fake_dlr.count,
    perPage: fake_dlr.per_page,
    service: auth.service,

    referencesLoading: references.reportLoading,
    e212List: e212.list,
    operatorDropdownList: e212.operator_dropdown_list,
    operatorDropdownLoading: e212.operator_dropdown_loading,
    countryDropdownList: e212.country_dropdown_list,
    countryDropdownLoading: e212.country_dropdown_loading,
    countryList: references.country_list,
    supplierList: fake_dlr.supplierList,
});

export default connect(mapState, {
    createApi: createFakeDLR,
    modifyApi: modifyFakeDLR,
    modifyMultirowApi: modifyMultirowFakeDLR,
    removeApi: removeFakeDLR,
    testRuleApi: testFakeDLRRule,

    getList: getFakeDLRList,
    getSupplierDropdownList,
    getE212DropdownList,
    getOperatorDropdownList,
    getCountryDropdownList,
    getFakeDLRSupplierList,
    getReferencesForReports
})(FakeDLRPage);
